// Resolve a carrier/provider name to its bundled logo image.
// Files live in public/assets/images/carriers/ (extensions vary).
// Returns the image path, or null when there's no logo for that carrier.
const LOGOS = [
  { test: /india\s*post/i, src: '/assets/images/carriers/indiapost-v2.svg' },
  { test: /fedex/i, src: '/assets/images/carriers/fedex.png' },
  { test: /dhl/i, src: '/assets/images/carriers/dhl.png' },
  { test: /aramex/i, src: '/assets/images/carriers/arame.png' },
  { test: /dtdc/i, src: '/assets/images/carriers/dtdc.png' },
  { test: /blue\s*dart/i, src: '/assets/images/carriers/bluedart.png' },
  { test: /\bups\b/i, src: '/assets/images/carriers/ups.png' },
];

export const carrierLogo = (name) => {
  if (!name) return null;
  const match = LOGOS.find((l) => l.test.test(name));
  return match ? match.src : null;
};
